var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6312"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6312"
    },
    "bundlingPackage": "documents-public-ui",
    "bundlingPackageVersion": "static-1.34648",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};